<template>
  <v-btn
    v-if="isBtnVisible"
    depressed
    color="primary"
    class="button-base"
    @click="btnClickHandler"
    :isLoading="isLoading"
  >
    Оформить довзыскание
  </v-btn>
</template>

<script>
import { StatementsModule } from '@/store/modules/statements';
import { RouteName } from '@/router';

export default {
  name: 'SurchargeBtn',
  props: {
    statusInfo: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    isBtnVisible() {
      return this.statusInfo.canBeSurcharge;
    },
  },
  methods: {
    async btnClickHandler() {
      this.isLoading = true;

      const statementId = await StatementsModule.createSurcharge({
        parentId: this.statusInfo.statementId,
      });

      this.isLoading = false;

      await this.$router.push({
        name: RouteName[this.statusInfo.statementType],
        params: { statementId },
      });
    },
  },
};
</script>
